export default __webpack_public_path__ + "static/media/dollar-icon.406061e2.svg";